module.exports = __webpack_public_path__ + "img/12-vogelspeelgoed_img2.bf2dd83f.jpg";